import React, { Component } from 'react';
import Terminal from 'react-console-emulator';
import ipfsClient from 'ipfs-http-client';

const ipfs = ipfsClient({host: 'ipfs.infura.io', port: '5001', protocol: 'https'});

const commands = {
  ls: {
    description: 'List contents of a directory',
    usage: 'ls <directory>',
    fn: async (dir) => {
      try {
        const files = await ipfs.files.ls(dir);
        return files.map(file => file.name).join('\n');
      } catch (e) {
        return e.message;
      }
    },
  },
  cat: {
    description: 'Display contents of a file',
    usage: 'cat <file>',
    fn: async (file) => {
      try {
        const content = await ipfs.files.read(`/ipfs/${file}`);
        return content.toString();
      } catch (e) {
        return e.message;
      }
    },
  },
  add: {
    description: 'Add a file to IPFS',
    usage: 'add <file>',
    fn: async (file) => {
      try {
        const results = await ipfs.add(file);
        return `Added ${results[0].path}`;
      } catch (e) {
        return e.message;
      }
    },
  },
};

export default class IPFSTerminal extends Component {
  render() {
    return (
      <Terminal
        commands={commands}
        welcomeMessage={'Welcome to the IPFS terminal!'}
        promptLabel={'ipfs $'}
      />
    );
  }
}
